import {Button, Datagrid, DatagridProps, FunctionField, NumberField, Record,} from "react-admin";

import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {initField} from "../../shared/utils";
import {Typography} from "@material-ui/core";


export const VerifiedChargesSummaryDatagrid = (props: DatagridProps) => {
  const { data: options } = useOptionsResource("GET");

  return options ? (
    <Datagrid
      hasBulkActions={true}
    >
      <FunctionField
        tabIndex={-1}
        sortable={false}
        label="Cliente"
        render={(tableRecord: Record | undefined) => {
          if (tableRecord) {
            return (
              <Button
                tabIndex={-1}
                //label={`${tableRecord.id}`}
                onClick={() => {
                  let urlParams: any = new URLSearchParams(window.location.search);
                  if (urlParams.has("filter")) {
                    let filter = urlParams.get("filter");
                    let json_filter = JSON.parse(filter)
                    json_filter.client = tableRecord.id
                    let json_string = JSON.stringify(json_filter)
                    json_string = json_string.replace(`"${tableRecord.id}"`, `${tableRecord.id}`)
                    urlParams.set("filter", json_string)
                  }
                  else {
                    let json_string = JSON.stringify({ "client": tableRecord.id })
                    json_string = json_string.replace(`"${tableRecord.id}"`, `${tableRecord.id}`)
                    urlParams.set("filter", json_string)
                  }
                  window.open("/verified-charges?" + urlParams.toString())

                }}
              >
                <Typography variant={"body2"}>{`${tableRecord.client__business_name} (${tableRecord.id})`}</Typography>
              </Button>
            );
          }
          return null;
        }}
      />

      <NumberField sortable={false} {...initField("taxable", options)} />

    </Datagrid>
  ) : null;
};
